/**
 * Created by bob.gear on 20/07/2015.
 */

angular.module("dialogService.module", [])
  .service("dialogService", [
    'ENUMS', 'dialogs', '$location', 'projectDataService', 'searchService',
    function (ENUMS, dialogs, $location, projectDataService, searchService) {

      this.contractFeedback = function (contract) {
        var dlg = dialogs.create('/app-ds3/feedback/feedback.dialog.html',
          'feedbackController',
          {
            projectName: contract.projectName,
            projectID: contract.projects[0].projectID,
            description1: contract.contractType,
            description2: contract.description,
            itemType: "Contract",
            url: $location.absUrl()
          },
          {
            size: 'md',
            keyboard: true,
            backdrop: 'static',
            windowClass: 'my-class'
          }
        );

        return dlg;
      };

      this.projectFeedback = function (project) {
        var dlg = dialogs.create('/app-ds3/feedback/feedback.dialog.html',
          'feedbackController',
          {
            projectName: project.projectName,
            projectID: project.projectID,
            description1: project.projectName,
            description2: project.energySector + " - " + project.projectType,
            itemType: "Project",
            url: $location.absUrl()
          },
          {
            size: 'md',
            keyboard: true,
            backdrop: 'static',
            windowClass: 'my-class'
          }
        );

        return dlg;
      };
      // a trivial change for GitHub testing
      this.openReportRequestDialog = function (reportParams) {
        var dlgReportRequest = dialogs.create('/app-ds3/reports/pdfReportRequest.dialog.html',
          'ReportRequestController',
          {
            reportParams: reportParams
          },
          {
            size: 'md',
            keyboard: true,
            backdrop: 'static',
            windowClass: 'my-class'
          }
        );

        // // If we are on a mobile, extra action is needed
        // // to posiion the dialog correctly. This need to be
        // // done on the next turn   
        if (window.innerWidth < 600) {
          setTimeout(function () {
            $(".modal-dialog").css({ left: 20, width: 350 });
            // $(".modal-dialog input:text").css({ width: 200 });
            // $(".modal-dialog textarea").css({ width: 200 });
          }, 200);
        };

        return dlgReportRequest;
      };

      //////////////////////////////////////////////////////////////////////
      ////  Open dialog for project export
      //////////////////////////////////////////////////////////////////////
      this.openExportRequestDialog = function (exportParams) {
        var dlgReportRequest = dialogs.create('/app-ds3/reports/exportRequest.dialog.html',
          'ExportRequestController',
          {
            exportParams: exportParams
          },
          {
            size: 'md',
            keyboard: true,
            backdrop: 'static',
            windowClass: 'my-class'
          }
        );
        // // If we are on a mobile, extra action is needed
        // // to posiion the dialog correctly. This need to be
        // // done on the next turn   
        if (window.innerWidth < 600) {
          setTimeout(function () {
            const leftBorder = 10;
            const topBorder = 5;
            const dialogWidth = window.innerWidth - (3 * leftBorder);
            $(".modal-dialog").css({
              left: leftBorder,
              top: topBorder,
              width: dialogWidth
            });
            const innerWidth = dialogWidth - 40
            $(".modal-dialog input:text").css({ width: 160, display: 'inline' });
            $(".modal-body table").css({ width: innerWidth });
            $(".modal-body fieldset").css({ width: innerWidth });
            $(".removeForMobile").css({ display: 'none' });
            $(".modal-body ").css({
              paddingTop: 2,
              paddingBottom: 2,
            });
            $(".modal-footer ").css({
              marginTop: 0,
              marginBottom: 0,
              paddingTop: 2,
              paddingBottom: 2,
            });
          }, 200);
        };
        return dlgReportRequest;
      };

      //////////////////////////////////////////////////////////////////////
      ////  Open dialog for selected project(s) watch
      //////////////////////////////////////////////////////////////////////
      this.openSelectedProjectWatchDialog = function (createReason) {
        var watchParameters;

        switch (createReason) {
          case ENUMS.PROJECT_WATCH_CREATE_REASONS.DYNAMIC_FROM_SEARCH:
            watchParameters = {
              watchType: 'projectCriteria',
              title: "",
              description: "",
              heading: "Watch Search Results",
              narrative: "Tell me when the results of this search change",
              searchGuid: searchService.queryDef.guid
            };
            break;

          case ENUMS.PROJECT_WATCH_CREATE_REASONS.SELECTED_PROJECTS_FROM_SEARCH:
            // form an array of selected projectIDs
            projectIDs = projectDataService.projectNames
              .filter(function (item, index, ar) {
                return item.isChecked;
              })
              .map(function (item, index, ar) {
                return item.projectID;
              });
            watchParameters = {
              watchType: 'selectedProjects',
              title: "",
              description: "",
              heading: "Watch Selected Projects",
              narrative: "Tell me when changes are made to any of the selected projects",
              projectIDs: projectIDs,
              searchGuid: searchService.queryDef.guid
            };
            break;

          case ENUMS.PROJECT_WATCH_CREATE_REASONS.INDIVIDUAL_PROJECT:
            // form an array of selected projectIDs
            var projectIDs = []
            projectIDs.push(projectDataService.project.projectID);

            watchParameters = {
              watchType: 'selectedProjects',
              title: projectDataService.project.projectName,
              description: "",
              heading: "Watch Selected Projects",
              narrative: "Tell me when changes are made to any of the selected projects",
              projectIDs: projectIDs
            };
            break;

          case ENUMS.PROJECT_WATCH_CREATE_REASONS.RECENTLY_ADDED_PROJECTS:
            // form an array of selected projectIDs
            var projectIDs = projectDataService.projectNames
              .filter(function (item, index, ar) {
                return item.isChecked;
              })
              .map(function (item, index, ar) {
                return item.projectID;
              });
            watchParameters = {
              watchType: 'selectedProjects',
              title: "",
              description: "",
              heading: "Watch Selected Projects",
              narrative: "Tell me when changes are made to any of the selected projects",
              projectIDs: projectIDs
            };
            break;

          default:
            Angular.noop();
        }

        watchParameters.createReason = createReason;
        this.createWatch(watchParameters);
      };

      this.createWatch = function (watchParameters) {
        var dlgCreateProjectWatch = dialogs.create('/app-ds3/notifications/createProjectWatch.dialog.html',
          'CreateProjectWatchController',
          {
            projectWatchParams: watchParameters
            //projectWatchParams: {
            //  watchType:    'any',
            //  title:         "",
            //  description:   "",
            //  projectIDs:    projectIDs
            //}
          },
          {
            size: 'md',
            keyboard: true,
            backdrop: 'static',
            windowClass: 'my-class'
          }
        );
        // // If we are on a mobile, extra action is needed
        // // to posiion the dialog correctly. This need to be
        // // done on the next turn   
        if (window.innerWidth < 600) {
          setTimeout(function () {
            const leftBorder = 15;
            const topBorder = 5;
            const dialogWidth = window.innerWidth - (2 * leftBorder);
            $(".modal-dialog").css({
              left: leftBorder,
              top: topBorder,
              width: dialogWidth
            });
            $(".modal-dialog input:text").css({ width: 200 });
            $(".modal-dialog textarea").css({ width: 200 });
            $(".removeForMobile").css({ display: 'none' });
            $(".modal-body ").css({
              // marginTop: 0,
              // marginBottom: 2,
              paddingTop: 2,
              paddingBottom: 2,
            });
            $(".modal-footer ").css({
              marginTop: 0,
              marginBottom: 0,
              paddingTop: 2,
              paddingBottom: 2,
            });
          }, 200);
        };
      };

      this.createWhatIfModel = function (whatIfParams) {
        var dlgReportRequest = dialogs.create('/app/businessDevelopmentTools/whatIf/createWhatIfModel.dialog.html',
          'CreateWhatIfController',
          {
            whatIfParams: whatIfParams
          },
          {
            size: 'md',
            keyboard: true,
            backdrop: 'static',
            windowClass: 'my-class'
          }
        );

        return dlgReportRequest;
      };
    }
  ])
  .controller('feedbackController', [
    '$scope', '$uibModalInstance', 'data', '$http',
    function ($scope, $uibModalInstance, data, $http) {
      $scope.data = data;

      $scope.send = function () {
        $http.post("/api/sendFeedbackMessage", $scope.data).then(function () {
          //success - thanks for taking time to tell us more about this...
          var i = 1;
          $scope.messageSent = true;
        },
          function () {
            // failure - there was an error and your message could not be sent
            // please report this failure to  EICDataSrtean Technical support
            var i = 1;
            $scope.messageFailed = true;
          });
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss();
      };

    }
  ])




  .controller('CreateWhatIfController', [
    '$scope',
    '$state',
    '$uibModalInstance',
    'data',
    'whatIfDialogService',
    'projectDataService',
    'FEATURE_SWITCHES',
    function ($scope, $state, $uibModalInstance, data, whatIfDialogService, projectDataService, FEATURE_SWITCHES) {

      $scope.componentName = "CreateWhatIfController";

      $scope.whatIfParams = data.whatIfParams;

      var successCallback = function (response) {
        $scope.success = true;
        $scope.requestSent = true;

        $scope.message = response.statusText;
        $scope.requestSentCloseButtonCaption = "OK";
        $scope.messageStyle = { 'color': 'black' };
      };

      var errorCallback = function (response) {
        $scope.success = false;
        $scope.requestSent = true;

        $scope.message = response.statusText;
        $scope.requestSentCloseButtonCaption = "Cancel";
        $scope.messageStyle = { 'color': 'red' };
      };

      var viewModel = function (whatIfModel) {
        $state.go("reports.whatIfAnalysis", { whatIfModel: whatIfModel });
      };


      $scope.createWhatIfModel = function () {
        // Here we create the what if model based on the list of projects we have been given
        // since we only get a list of project IDs, the first thing the view page has to do is
        // to refresh the data fields. That ties in well with the workflow
        //


        // as per John Papa, don't make the http call directly. Set up and
        // inject a service to  do  this so that  the controller is not
        // polluted with things that  are not its direct concern.
        // this has the by-product of making the controller instantly more testable.
        // this same principle should probably be extended to  handling the dialog
        // $scope.whatIfParams.fileName = $scope.whatIfParams.fileName + ".pdf";
        //
        // var whatif = whatIfDialogService.submit($scope.whatIfParams)
        //   .then(successCallback, errorCallback);
        // $scope.whatIfParams.projectIDs,
        var whatIfModel = {
          projects: [],
          // other properties that have not yet been initialised
          revenueRange: { min: 0, max: 0, divisions: 6 },
          revenuebins: [],
          scenarioTotals: [],
          scenarios: {},

          // include internal functions that  make the simulations run
          calculate: function () {
            this.projects.forEach(function (project) {
              project.calculatePotentialRevenue();
              project.calculateMonteCarloSimulations();

            });

            var that = this;
            // now compute the scenario totals
            this.scenarioTotals.length = 0;
            for (var i = 0; i < 100; i++) {
              this.scenarioTotals.push(0);
              this.projects.forEach(function (project) {
                that.scenarioTotals[i] = that.scenarioTotals[i] + project.monteCarloSimulations[i];
              });
            }

            // get the min and max values of all the scenario totals
            // this tells us what range needs to be accomodated on charts etc.
            this.revenueRange.min = Math.floor(Math.min.apply(null, this.scenarioTotals));
            this.revenueRange.max = Math.ceil(Math.max.apply(null, this.scenarioTotals));

            // for the purpose of the histogram, we need to decide how
            // big the bins are and then compute the frequency for each bin
          },

          computeScenarioFrequencies: function () {
            // initially at least, comput 1000 iterations
            for (var i = 0; i < 1000; i++) {
              var scenarioKey = "";
              var scenarioProjects = [];

              var that = this;
              this.projects.forEach(function (project) {
                // compute outcome for each project
                var success = (Math.random() > 1 - project.successProbability);

                // compose a scenario key cased on the ids of the successful projects
                // compose a list of successful projects in this scenario
                if (success) {
                  scenarioKey = scenarioKey + project.projectID.toString();
                  scenarioProjects.push(project);
                }
              });

              // if the scenario does not already exist, create it.
              // if it does. increment the scenario frequency
              if (!that.scenarios[scenarioKey]) {
                that.scenarios[scenarioKey] = {};

                that.scenarios[scenarioKey].frequency = 0;
                that.scenarios[scenarioKey].projects = scenarioProjects;
              }
              that.scenarios[scenarioKey].frequency++;
            }

          }
        };





        // load the projectIDs by creating a project structure and pushing it into the array
        $scope.whatIfParams
          .projectIDs
          .forEach(function (projectID) {
            var project = {
              projectID: projectID,
              value: null,
              percentageTake: null,
              successProbability: null,
              potentialRevenue: 0,
              monteCarloSimulations: [],

              calculatePotentialRevenue: function () {
                this.potentialRevenue = this.percentageTake * this.dollarValue
              },

              calculateMonteCarloSimulations: function () {
                for (var i = 0; i < 100; i++) {
                  var chance = Math.random();

                  var simulatedRevenue = null;
                  if (chance > 1 - this.successProbability) {
                    this.monteCarloSimulations[i] = this.potentialRevenue;
                  } else {
                    this.monteCarloSimulations[i] = null;
                  }
                }
              }
            };
            whatIfModel.projects.push(project);

          });

        viewModel(whatIfModel);
      };


      $scope.cancel = function () {
        $uibModalInstance.dismiss('Canceled');
      }; // end cancel

      $scope.hitEnter = function (evt) {
        if (angular.equals(evt.keyCode, 13) && !(angular.equals($scope.user.name, null) || angular.equals($scope.user.name, '')))
          $scope.save();
      };


      //$scope.$watch("whatIfParams.title", function () {
      //  if ($scope.createWhatIfDialog.txtFileName.$pristine) {
      //    // replace any illegal file characters with "_" and spaces with "-"
      //    $scope.whatIfParams.fileName = $scope.whatIfParams.title
      //        .replace(/[\\\/:*?"<>|]{1,}/g, "_")
      //        .replace(/[ ]{1,}/g, "-")
      //      //.replace(/[_]|(.)\1/g, "_")
      //      //.replace(/[-]\1/g, "-")
      //      ;
      //  }

      //}, true);

      //     $scope.selectedNoteTypesChanged();
      $scope.$on('$viewContentLoaded', function () {
      });

    }
  ])
  .service('whatIfDialogService', [
    '$http', 'dialogService', 'projectDataService',
    function ($http, dialogService, projectDataService) {

      //////////////////////////////////////////////////////////////////////
      ////  Open dialog for New What-If Analysis - Selected Projects
      //////////////////////////////////////////////////////////////////////

      this.open_selectedProjects = function () {

        var projectIDs = getSelectedProjectIDs();

        // HACK ALERT
        // if no projects have been explicitly chosen, then select all
        // those that  match the TrackingStatus selection
        if (projectIDs.length == 0) {
          projectIDs = getAllVisibleProjectIDs();
        }

        var whatIfParams = {
          title: "",
          description: "",
          fileName: "",
          highlightDays: 28,
          newModel: true,

          sort: {
            order: "ProjectName",
            direction: "ASC",
            pageBreak: false
          },
          criteria: "",
          projectIDs: projectIDs,
          noteTypeIDs: [],
          trackingStatusIDs: [],

        };


        dialogService.createWhatIfModel(whatIfParams);
      };

      //////////////////////////////////////////////////////////////////////
      ////  Support Functions - TODO: break these out into a library
      //////////////////////////////////////////////////////////////////////

      var getSelectedProjectIDs = function () {
        return projectDataService.projectNames
          .filter(function (item, index, ar) {
            if (item.isChecked) return true;
          }
          ).map(function (item, index, ar) {
            return item.projectID;
          }
          );
      };

      var getAllVisibleProjectIDs = function () {
        return projectDataService.projectNames
          .filter(function (item, index, ar) {
            if (trackingStatusService.selectedValues.indexOf(item.trackingStatusID) > -1) return true;
          })
          .map(function (item, index, ar) {
            return item.projectID;
          }
          );
      };

      //////////////////////////////////////////////////////////////////////
      this.submit = function (whatIfParams) {
        return $http.post('/api/whatIFModel', whatIfParams);
      };

    }
  ]);
